(function () {
  var WRAPPER_ID = 'gs-builder-app-block';
  var STUCK_CLASS = 'gs-builder-btn--stuck';
  var SENTINEL_CLASS = 'gs-builder-sentinel';

  function isSized(el) {
    if (!el || !el.isConnected) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 1 && rect.height > 1;
  }

  function matchesBuildText(el) {
    var text = (el.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
    return text.indexOf('build') !== -1 && text.indexOf('gang sheet') !== -1;
  }

  function findTarget() {
    var byId = document.getElementById('gs-builder-btn');
    if (byId && isSized(byId)) return byId;

    // Only search WITHIN the gang-sheet-builder app block. Searching the
    // whole document made the "build + gang sheet" text heuristic match
    // unrelated links (e.g. a blog card titled "How to Build a DTF
    // Transfers Gang Sheet…"), which got yanked out and appended after
    // the footer. No wrapper on the page = no sticky button to manage.
    var wrapper = document.getElementById(WRAPPER_ID);
    if (!wrapper) return null;
    var candidates = wrapper.querySelectorAll('button, a, [role="button"], .gs--button');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!matchesBuildText(el)) continue;
      if (!isSized(el)) continue;
      return el;
    }
    return null;
  }

  var ctx = {
    target: null,
    sentinel: null,
    home: null,
    homeNext: null,
    rafQueued: false,
    listenersOn: false,
    mo: null
  };

  function ensureSentinel(target) {
    if (ctx.sentinel && ctx.sentinel.isConnected) return ctx.sentinel;
    var sentinel = document.createElement('div');
    sentinel.className = SENTINEL_CLASS;
    sentinel.style.cssText = 'height:1px;margin:0;padding:0;pointer-events:none;visibility:hidden;';
    target.parentNode.insertBefore(sentinel, target);
    ctx.sentinel = sentinel;
    return sentinel;
  }

  function rememberHome(target) {
    if (ctx.home && ctx.home.isConnected) return;
    ctx.home = target.parentNode;
    ctx.homeNext = target.nextSibling;
  }

  function restoreHome(target) {
    if (!ctx.home || !ctx.home.isConnected) return;
    if (target.parentNode === ctx.home) return;
    if (ctx.homeNext && ctx.homeNext.parentNode === ctx.home) {
      ctx.home.insertBefore(target, ctx.homeNext);
    } else {
      ctx.home.appendChild(target);
    }
  }

  function setStuck(yes) {
    if (!ctx.target) return;
    var stuck = ctx.target.classList.contains(STUCK_CLASS);
    if (yes && !stuck) {
      var h = ctx.target.getBoundingClientRect().height || 60;
      if (ctx.sentinel) ctx.sentinel.style.height = h + 'px';
      rememberHome(ctx.target);
      if (ctx.target.parentNode !== document.body) {
        document.body.appendChild(ctx.target);
      }
      ctx.target.classList.add(STUCK_CLASS);
    } else if (!yes && stuck) {
      ctx.target.classList.remove(STUCK_CLASS);
      restoreHome(ctx.target);
      if (ctx.sentinel) ctx.sentinel.style.height = '1px';
    }
  }

  function update() {
    ctx.rafQueued = false;
    if (!ctx.target || !ctx.sentinel) return;
    if (!ctx.target.isConnected) {
      var fresh = findTarget();
      if (fresh && fresh !== ctx.target) rebind(fresh);
      return;
    }
    var rect = ctx.sentinel.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var notVisible = rect.bottom < 0 || rect.top > vh;
    setStuck(notVisible);
  }

  function scheduleUpdate() {
    if (ctx.rafQueued) return;
    ctx.rafQueued = true;
    requestAnimationFrame(update);
  }

  function teardown() {
    if (ctx.target) {
      ctx.target.classList.remove(STUCK_CLASS);
      restoreHome(ctx.target);
    }
    if (ctx.sentinel && ctx.sentinel.parentNode) {
      ctx.sentinel.parentNode.removeChild(ctx.sentinel);
    }
    ctx.target = null;
    ctx.sentinel = null;
    ctx.home = null;
    ctx.homeNext = null;
  }

  function rebind(newTarget) {
    teardown();
    ctx.target = newTarget;
    if (!newTarget) return;
    ensureSentinel(newTarget);
    scheduleUpdate();
  }

  function attachListeners() {
    if (ctx.listenersOn) return;
    ctx.listenersOn = true;
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
  }

  function attachMutationObserver() {
    if (ctx.mo) return;
    var bodyMo = new MutationObserver(function () {
      if (!ctx.target || !ctx.target.isConnected) {
        var fresh = findTarget();
        if (fresh && fresh !== ctx.target) rebind(fresh);
      }
    });
    try {
      bodyMo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { try { bodyMo.disconnect(); } catch (_) {} ctx.mo = null; }, 60000);
      ctx.mo = bodyMo;
    } catch (_) {}
  }

  function init() {
    var target = findTarget();
    if (!target) return false;
    if (ctx.target === target) return true;
    rebind(target);
    attachListeners();
    attachMutationObserver();
    return true;
  }

  function start() {
    if (init()) return;
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (init() || attempts > 60) clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
